
import React, { useMemo, useState } from "react";

import SearchHeader
from "../../../components/SearchHeader";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faFilePdf,
    faChevronRight,
    faArrowLeft
}
from "@fortawesome/free-solid-svg-icons";


//========================================================
// OmniScan Colours
//========================================================

const OMNISCAN_BLUE = "#20AFE8";

const OMNISCAN_BLUE_RGB = "32, 175, 232";

const DRAWER_BACKGROUND =
    "linear-gradient(180deg, " +
    "rgba(27,38,49,0.96) 0%, " +
    "rgba(18,28,39,0.97) 100%)";


//========================================================
// Asset Documents Drawer
//========================================================

export default function AssetDocumentsDrawer()
{
    const [search, setSearch] =
        useState("");

    const [selectedDocument, setSelectedDocument] =
        useState(null);


    //----------------------------------------------------
    // Documents
    //----------------------------------------------------

    const documents = useMemo(() => [
        {
            title: "OmniScanPro Reference Guide",
            date: "12 Aug 2026",
            size: "4.4 MB",
            url: "/demo/fcu.pdf"
        },
        {
            title: "2nd Floor High Level Cooling.pdf",
            date: "12 Jan 2026",
            size: "2.4 MB",
            url: "/demo/document1.pdf"
        },
        {
            title: "Certificate of Completion.pdf",
            date: "19 Feb 2026",
            size: "4.8 MB",
            url: "/demo/document2.pdf"
        },
        {
            title: "Level 1 Electrical Riser Outstation.pdf",
            date: "08 Mar 2026",
            size: "1.2 MB",
            url: "/demo/document3.pdf"
        },
        {
            title: "PPM Schedule.pdf",
            date: "17 Apr 2026",
            size: "930 KB",
            url: "/demo/document4.pdf"
        },
        {
            title: "Spigot Commissioning.pdf",
            date: "01 May 2026",
            size: "6.7 MB",
            url: "/demo/document5.pdf"
        }
    ], []);


    //----------------------------------------------------
    // Filter Documents
    //----------------------------------------------------

    const filtered = useMemo(() =>
    {
        const query = search.trim().toLowerCase();

        return documents.filter(document =>
            document.title
                .toLowerCase()
                .includes(query)
        );

    }, [documents, search]);


    //----------------------------------------------------
    // Document Viewer
    //----------------------------------------------------

    if(selectedDocument)
    {
        return (

            <div
                style={{
                    height: "100%",
                    minHeight: 0,

                    display: "flex",
                    flexDirection: "column",

                    background: DRAWER_BACKGROUND
                }}
            >

                {/* BACK BUTTON */}

                <div
                    onClick={() =>
                        setSelectedDocument(null)
                    }

                    role="button"
                    tabIndex={0}

                    onKeyDown={event =>
                    {
                        if(
                            event.key === "Enter" ||
                            event.key === " "
                        )
                        {
                            event.preventDefault();
                            setSelectedDocument(null);
                        }
                    }}

                    style={{
                        height: "64px",
                        minHeight: "64px",

                        display: "flex",
                        alignItems: "center",

                        padding: "0 22px",

                        cursor: "pointer",

                        background:
                            "rgba(255,255,255,0.035)",

                        borderBottom:
                            "1px solid rgba(255,255,255,0.10)",

                        color: "#8DC8F0",

                        fontWeight: 600,

                        gap: "12px"
                    }}
                >

                    <FontAwesomeIcon
                        icon={faArrowLeft}
                    />

                    Back to Documents

                </div>


                {/* PDF VIEWER */}

                <iframe
                    title="Document"

                    src={selectedDocument}

                    style={{
                        flex: 1,
                        minHeight: 0,

                        width: "100%",

                        border: "none",

                        background: "#ffffff"
                    }}
                />

            </div>

        );
    }


    //----------------------------------------------------
    // Document List
    //----------------------------------------------------

    return (

        <div
            className="asset-documents-drawer"

            style={{
                height: "100%",
                minHeight: 0,

                display: "flex",
                flexDirection: "column",

                boxSizing: "border-box",

                background: DRAWER_BACKGROUND,

                color: "#ffffff",

                overflow: "hidden"
            }}
        >

            {/* LOCAL STYLING */}

            <style>
                {`
                    /*----------------------------------
                      Native Dark Scrollbar
                    ----------------------------------*/

                    .asset-documents-scroll {
                        scrollbar-width: thin;

                        scrollbar-color:
                            rgba(92,151,184,0.45)
                            transparent;

                        overscroll-behavior: contain;
                    }

                    .asset-documents-scroll::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                    }

                    .asset-documents-scroll::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .asset-documents-scroll::-webkit-scrollbar-thumb {
                        background:
                            rgba(92,151,184,0.45);

                        border-radius: 6px;
                    }

                    .asset-documents-scroll::-webkit-scrollbar-thumb:hover {
                        background:
                            rgba(32,175,232,0.75);
                    }


                    /*----------------------------------
                      Document Card Hover
                    ----------------------------------*/

                    .asset-documents-drawer
                    .asset-document-card:hover {
                        background:
                            linear-gradient(
                                135deg,
                                rgba(55,75,94,0.88),
                                rgba(30,46,62,0.94)
                            ) !important;

                        border-color:
                            rgba(32,175,232,0.48) !important;

                        transform: translateY(-1px);
                    }

                    .asset-documents-drawer
                    .asset-document-card:focus-visible {
                        outline: 2px solid #20AFE8;
                        outline-offset: 2px;
                    }
                `}
            </style>


            {/* SEARCH HEADER */}

            <div
                style={{
                    padding: "24px 24px 18px 24px",

                    flexShrink: 0,

                    background:
                        "rgba(255,255,255,0.025)",

                    borderBottom:
                        "1px solid rgba(255,255,255,0.07)"
                }}
            >

                <div
                    style={{
                        padding: "10px 14px",

                        background:
                            "rgba(255,255,255,0.045)",

                        border:
                            "1px solid rgba(255,255,255,0.10)",

                        boxShadow:
                            "0 4px 16px rgba(0,0,0,0.10)"
                    }}
                >

                    <SearchHeader
                        placeholder="Search documents..."

                        value={search}

                        onChange={setSearch}

                        count={filtered.length}

                        label="Documents"
                    />

                </div>

            </div>


            {/* NATIVE SCROLLABLE DOCUMENT LIST */}

            <div
                className="asset-documents-scroll"

                style={{
                    flex: 1,

                    minHeight: 0,

                    overflowY: "auto",
                    overflowX: "hidden",

                    padding: "22px 24px 24px 24px",

                    boxSizing: "border-box"
                }}
            >

                {
                    filtered.map((doc, index) =>

                        <DocumentCard
                            key={doc.url || index}

                            document={doc}

                            onClick={() =>
                                setSelectedDocument(doc.url)
                            }
                        />

                    )
                }


                {/* NO RESULTS */}

                {
                    filtered.length === 0 &&

                    <div
                        style={{
                            padding: "32px 20px",

                            textAlign: "center",

                            color: "#a9c1d1",

                            fontSize: "14px",

                            background:
                                "rgba(255,255,255,0.035)",

                            border:
                                "1px solid rgba(255,255,255,0.08)"
                        }}
                    >

                        No matching documents found.

                    </div>
                }

            </div>

        </div>

    );
}


//========================================================
// Document Card
//========================================================

function DocumentCard({
    document,
    onClick
})
{
    return (

        <div
            className="asset-document-card"

            onClick={onClick}

            role="button"
            tabIndex={0}

            onKeyDown={event =>
            {
                if(
                    event.key === "Enter" ||
                    event.key === " "
                )
                {
                    event.preventDefault();
                    onClick();
                }
            }}

            style={{
                display: "flex",

                alignItems: "center",

                justifyContent: "space-between",

                gap: "16px",

                padding: "18px",

                marginBottom: "14px",

                borderRadius: "0px",

                cursor: "pointer",

                background:
                    "linear-gradient(135deg, " +
                    "rgba(48,63,79,0.72) 0%, " +
                    "rgba(25,38,52,0.82) 100%)",

                border:
                    "1px solid rgba(255,255,255,0.11)",

                boxShadow:
                    "0 4px 14px rgba(0,0,0,0.14)",

                transition:
                    "background .2s ease, " +
                    "border-color .2s ease, " +
                    "transform .2s ease"
            }}
        >

            {/* DOCUMENT INFORMATION */}

            <div
                style={{
                    display: "flex",

                    alignItems: "center",

                    minWidth: 0,

                    flex: 1
                }}
            >

                {/* PDF ICON */}

                <div
                    style={{
                        width: "48px",
                        height: "48px",

                        minWidth: "48px",

                        borderRadius: "50%",

                        background:
                            "rgba(220,38,38,0.12)",

                        border:
                            "1px solid rgba(248,113,113,0.32)",

                        color: "#ff7777",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        fontSize: "20px",

                        boxShadow:
                            "0 3px 12px rgba(0,0,0,0.10)"
                    }}
                >

                    <FontAwesomeIcon
                        icon={faFilePdf}
                    />

                </div>


                {/* TITLE AND METADATA */}

                <div
                    style={{
                        marginLeft: "16px",

                        minWidth: 0
                    }}
                >

                    <div
                        style={{
                            color: "#f1f6fb",

                            fontWeight: 600,

                            fontSize: "15px",

                            lineHeight: "1.45",

                            overflowWrap: "anywhere"
                        }}
                    >

                        {document.title}

                    </div>

                    <div
                        style={{
                            marginTop: "5px",

                            color: "#a9c1d1",

                            fontSize: "12px",

                            fontWeight: 400
                        }}
                    >

                        {document.date}
                        {" • "}
                        {document.size}

                    </div>

                </div>

            </div>


            {/* NAVIGATION ARROW */}

            <FontAwesomeIcon
                icon={faChevronRight}

                style={{
                    color: OMNISCAN_BLUE,

                    opacity: 0.85,

                    fontSize: "15px",

                    flexShrink: 0
                }}
            />

        </div>

    );
}
